import React from 'react';
import { connect } from 'react-redux';
import striptags from 'striptags';
import ucfirst from 'ucfirst';
import urlparam from 'urlparam';
import APIConnectionWarning from '../../elements/APIConnectionWarning/APIConnectionWarning';
import Blocklink from '../../elements/Blocklink';
import { dialogAlert } from '../../elements/Dialog/dialogs';
import Input from '../../elements/forms/Input';
import HomeLogo from '../../elements/HomeLogo';
import Link from '../../elements/Link';
import Scrollable from '../../elements/Scrollable';
import TopBar from '../../elements/TopBar/TopBar';
import Screen from '../Screen';

class LoginViaEmail extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            email: urlparam('email') || '',
            password: '',
        };
    }
    render() {
        let { i18n, prefill } = this.props,
            header = (
                <>
                    <TopBar returnURL="/login" title={i18n['label.login']} />
                    {prefill ? (
                        <div>
                            <img
                                src={prefill.summary.logo_url}
                                style={{
                                    width: '100%',
                                }}
                            />
                            <h1>{prefill.summary.name}</h1>
                        </div>
                    ) : (
                        <HomeLogo />
                    )}
                </>
            ),
            footer = <APIConnectionWarning />;

        return (
            <Screen header={header} footer={footer} className="authentication-screen">
                <Scrollable>
                    <form onSubmit={this.handleSubmit.bind(this)} action="#">
                        <h1>{i18n['label.login.by.e-mail']}</h1>
                        <div className="content">
                            <div>{i18n['label.fill.details.below']}</div>
                            <Input
                                type="email"
                                label={i18n['label.email.address']}
                                onKeyDown={this.handleEmailKeyDown.bind(this)}
                                value={this.state.email}
                                onChange={this.handleChange.bind(this, 'email')}
                                autoFocus
                            />
                            <Input type="password" label={i18n['label.password']} value={this.state.password} onChange={this.handleChange.bind(this, 'password')} />
                            <br />
                            <div className="text-right">
                                <Link href="/password_recover">{i18n['label.forgotPassword']}</Link>
                            </div>
                            <br />
                        </div>
                        <Blocklink type="submit" className="text-right" next disabled={this.props.busy}>
                            {i18n['label.loginAction']}
                        </Blocklink>
                    </form>
                </Scrollable>
            </Screen>
        );
    }
    handleChange(field, value) {
        this.setState({ [field]: value });
    }
    handleEmailKeyDown(e) {
        if (e.keyCode == 13) {
            e.preventDefault();
            e.stopPropagation();
            try {
                document.querySelector('input[type="password"]').focus();
            } catch (e) {
                console.error(e);
            }
        }
    }
    handleSubmit(e) {
        e.preventDefault();
        this.login();
    }
    login() {
        app.store.dispatch(app.actions.ui.busy());
        app.api.session
            .login(this.state.email, this.state.password)
            .then(() => {
                if (this.props.prefill) {
                    app.history.push('/add/' + this.props.prefill.code);
                }
                app.store.dispatch(app.actions.ui.free());
            })
            .catch(async (error) => {
                app.store.dispatch(app.actions.ui.free());
                if (error.status == 401 && error.response?.data?.error == 'password_reset') {
                    error = this.props.i18n['message.forced-password-reset'];
                } else {
                    error = ucfirst(striptags(_(error).get('response.data.error_message', this.props.i18n['message.networkerror'])));
                }
                await dialogAlert(error);
            });
    }
}

const ConnectedScreen = connect(function (state, props) {
    let i18n = state.i18n.translations;
    return {
        i18n,
        prefill: state.session.prefill,
        busy: !!state.ui.pendingTasks,
    };
})(LoginViaEmail);

export default ConnectedScreen;
